import { action, observable, computed } from "mobx";
import MainEntity from "../../MainEntity";


/**
 * 시스템 - 사용자 Entity
 */
export default abstract class TbSysUserEntity extends MainEntity {
  @observable userId?: string;
  @observable loginNm?: string;
  @observable loginPassword?: string;
  @observable useYn?: boolean;
  @observable userLocale?: string;
  @observable passwordChangeDe?: Date;
  @observable passwordEndDe?: Date;
  @observable beforeLoginDt?: Date;
  @observable lastLoginDt?: Date;

  constructor(data?) {
    super(data);
 }

  @computed
  public getUserId() {
    return this.userId;
  }

  @action
  public setUserId(userId: string) {
    this.userId = userId;
  }

  @computed
  public getLoginNm() {
    return this.loginNm;
  }

  @action
  public setLoginNm(loginNm: string) {
    this.loginNm = loginNm;
  }

  @computed
  public getLoginPassword() {
    return this.loginPassword;
  }

  @action
  public setLoginPassword(loginPassword: string) {
    this.loginPassword = loginPassword;
  }

  @computed
  public getUseYn() {
    return this.useYn;
  }

  @action
  public setUseYn(useYn: boolean) {
    this.useYn = useYn;
  }

  @computed
  public getUserLocale() {
    return this.userLocale;
  }

  @action
  public setUserLocale(userLocale: string) {
    this.userLocale = userLocale;
  }

  @computed
  public getPasswordChangeDe() {
    return this.passwordChangeDe;
  }

  @action
  public setPasswordChangeDe(passwordChangeDe: Date) {
    this.passwordChangeDe = passwordChangeDe;
  }

  @computed
  public getPasswordEndDe() {
    return this.passwordEndDe;
  }

  @action
  public setPasswordEndDe(passwordEndDe: Date) {
    this.passwordEndDe = passwordEndDe;
  }

  @computed
  public getBeforeLoginDt() {
    return this.beforeLoginDt;
  }

  @action
  public setBeforeLoginDt(beforeLoginDt: Date) {
    this.beforeLoginDt = beforeLoginDt;
  }

  @computed
  public getLastLoginDt() {
    return this.lastLoginDt;
  }

  @action
  public setLastLoginDt(lastLoginDt: Date) {
    this.lastLoginDt = lastLoginDt;
  }
}
